import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InventoryCategory } from '@contracts/interfaces/inventory-category';
import { InventoryCategoryService } from '../../services/inventory-category.service';
import { InventoryCategoryFactory } from '../../factories/inventory-category.factory';

export interface DialogData {

}

@Component({
  selector: 'app-dialog-inventory-category-new',
  templateUrl: 'inventory-category-new.dialog.html',
  styleUrls: ['./inventory-category-new.dialog.scss']
})
export class InventoryCategoryNewDialogComponent {

  public name = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<InventoryCategoryNewDialogComponent>,
    public inventoryCategoryService: InventoryCategoryService 
    ) { }

  ngOnInit() {


  }

  save () {
    let category = InventoryCategoryFactory.default;
    category.name = this.name;
    category.nicename = this.name;

    this.inventoryCategoryService.create(category).subscribe((category: InventoryCategory) => {
      //console.log(category)
      this.dialogRef.close(category);
    })
  }
}
